/** Sample form data for auto-fill on Policy Type create form. */
export type PolicyTypeFormSample = {
    name: string;
    description?: string | null;
    orderIndex?: number;
};

export const policyTypeFormSamples: PolicyTypeFormSample[] = [
    {
        name: 'ລະບຽບການລາ',
        description: 'ລວມນະໂຍບາຍກ່ຽວກັບສິດການລາ ແລະ ຂັ້ນຕອນອະນຸມັດ',
        orderIndex: 1,
    },
    {
        name: 'ລະບຽບ OT',
        description: 'ນະໂຍບາຍການເຮັດວຽກນອກເວລາ ແລະ ການຄິດໄລ່ຄ່າຕອບແທນ',
        orderIndex: 2,
    },
    {
        name: 'ຄວາມປອດໄພໃນການເຮັດວຽກ',
        description: 'ກຳນົດຫຼັກເກນຄວາມປອດໄພ ແລະ ຂໍ້ປະຕິບັດພື້ນຖານ',
        orderIndex: 3,
    },
    {
        name: 'ຈັນຍາບັນອົງກອນ',
        description: 'ແນວທາງຈັນຍາບັນ ແລະ ພຶດຕິກຳໃນບ່ອນເຮັດວຽກ',
        orderIndex: 4,
    },
];
